import { Route, Routes as RoutesInner } from 'react-router-dom';
import Main from './components/Main';
import Quiz from './components/Quiz';
import Subscription from './components/Subscription';
import SignIn from './components/SignIn';
import DownloadApp from './components/DownloadApp';
import Unsubscribe from './components/Unsubscribe';
import React from 'react';
import { Routes } from './App';
import { useCheckAuth } from '@hooks/useCheckAuth';
import Advantages from '@components/Advantages';

export default function Router() {
  useCheckAuth();

  return (
    <RoutesInner>
      <Route path={Routes.MAIN + '*'} element={<Main />} />
      <Route path={Routes.QUIZ} element={<Quiz />} />
      <Route path={Routes.SUBSCRIPTION} element={<Subscription />} />
      <Route path={Routes.ADVANTAGES} element={<Advantages />} />
      <Route path={Routes.SIGN_IN} element={<SignIn />} />
      <Route path={Routes.ACTIVATE_ME} element={<SignIn />} />
      <Route path={Routes.DOWNLOAD_APP} element={<DownloadApp />} />
      <Route path={Routes.UNSUBSCRIBE} element={<Unsubscribe />} />
    </RoutesInner>
  );
}
